const API = window.API
const defaultData = {
    width: 1017,
    height: 700
}
let hasNewTab = false
let lastUrl = ''
let flagTimer = true

/**
 * 最小化窗口
 */
export function viewHide () {
    API.use({
        method: 'external.minimizeWindow',
        success: data => {
            console.log('success:mini', data);
        }
    })
}

/**
 * 最大化窗口
 */
export function viewFullPage (fn) {
    changeViewSize(screen.availWidth, screen.availHeight, 'center', fn)
}

/**
 * 取消最大化
 */
export function viewFullPageCancel (fn, width = defaultData.width, height = defaultData.height) {
    changeViewSize(width, height, 'center', fn)
}

/**
 * 关闭窗口
 */
export function viewClose () {
    closeNewTab()
    API.use({
        method: 'external.closeWebDlg'
    })
}

/**
 * 移动窗口位置
 * @param {Number} data 类别
 * @param {Function} cb 执行后的回调函数
 */
export function viewMove (data = 1, cb) {
    API.use({
        method: 'external.moveWindowByMessage',
        data: data,
        success: () => {
            cb && cb()
        }
    })
}

/**
 * 调整框尺寸
 * @param {Number} width 宽度
 * @param {Number} height 高度
 * @param {String} type 类型
 */
export function changeViewSize (width = defaultData.width, height = defaultData.height, type, fn) {
    API.use({
        method: 'external.setWindowRect',
        data: {
            width: width,
            height: height,
            moveStyle: type
        },
        success: () => {
            if (fn) fn()
        }
    })
}

/**
 * 获取股票名称
 * @param {Number} code 股票代码
 * @return {Promise}
 */
export function getStockName (code) {
    return new Promise((resolve, reject) => {
        API.use({
            method: 'Quote.getData',
            data: {
                code: code,
                type: 'ZQMC'
            },
            success: (data) => {
                // eslint-disable-next-line
                resolve(eval(data))
            }
        })
    })
}

/**
 * 获取窗口下的主入口
 * @return {Promise}
 */
export function GetMainWindowCode (code) {
    return new Promise((resolve, reject) => {
        API.use({
            method: 'Util.GetMainWindowCode',
            success: (data) => {
                // console.log( data)
                // eslint-disable-next-line
                if(data){
                    resolve(data)
                }else{
                    reject(data)
                }
            }
        })
    })
}
/**
 * 根据 type 获取 treeid
 */
export function getTreeids () {
    return new Promise((resolve, reject) => {
        const types = ['20de2', '20de1', '20dd7','134621']
        let getTreeidArr = []
        types.map(item => {
            getTreeidArr.push(getTreeid(item))
        })
        Promise.all(getTreeidArr)
            .then(data => {
                resolve(data)
            })
            .catch(e => {
                console.warn(e)
            })
    })
}

/**
 * 根据 typeId 获取 treeid
 * @param {String} typeId
 */
function getTreeid (typeId) {
    return new Promise((resolve, reject) => {
        typeId = parseInt(typeId, 16)
        API.use({
            method: 'info.getInfoIdsByType',
            data: typeId,
            success: (data) => {
                // eslint-disable-next-line
                resolve(eval(data)[0].toString())
            }
        })
    })
}

/**
 * 获取 infoobj
 */
export function getInfoObj (data, sessid) {
    return new Promise((resolve, reject) => {
        window.API.use({
            method: 'info.getInfoObject',
            data: data,
            sessionId: sessid,
            // persistent: true,
            success: function (data) {
                resolve(JSON.parse(data))
            }
        })
    })
}
/**
 * 全量获取 infoobj
 */
export function getInfoObjs (data, sessid) {
    return new Promise((resolve, reject) => {
        window.API.use({
            method: 'info.getInfoObjects',
            data: data,
            sessionId: sessid,
            // persistent: true,
            success: function (data) {
                resolve(JSON.parse(data))
            }
        })
    })
}
/**
 * 判断涨停
 */
export function IsStockLimitUp ( data) {
    let sessionId = API.createSessionId('Info')
    return new Promise((resolve, reject) => {
        window.API.use({
            method: 'util.IsStockLimitUp',
            data: data,
            sessionId: sessionId,
            // persistent: true,
            success: function (data) {
                resolve(JSON.parse(data))
            }
        })
    })
}

/**
 * setInfo
 */
export function setInfo (data, sessid) {
    return new Promise((resolve, reject) => {
        window.API.use({
            method: 'infoObject.setInfo',
            data: data,
            sessionId: sessid,
            // persistent: true,
            success: function (data) {
                resolve(data)
            }
        })
    })
}

/**
 * getExtra
 */
export function getExtra (data, sessid) {
    return new Promise((resolve, reject) => {
        window.API.use({
            method: 'infoObject.getExtra',
            data: data,
            sessionId: sessid,
            persistent: true,
            success: function (data) {
                resolve(data)
            }
        })
    })
}

/**
 * getNewsUrl
 */
export function getNewsUrl (data, sessid) {
    return new Promise((resolve, reject) => {
        window.API.use({
            method: 'infoObject.getNewURL',
            data: data,
            sessionId: sessid,
            // persistent: true,
            success: function (data) {
                resolve(data)
            }
        })
    })
}

/**
 * 获取列表
 */
export function getList (params = {code, treeid,industry} ) {
    /**
     * |market|              "17"|            市场代码|
     * |code|                "603363"|        股票代码|
     * |start|               "0"|             起始时间|
     * |end|                 "0"|             结束时间|
     * |period|              "-1|"            周期|
     * |industry|            "" |             代码对应行业|
     * |objid|               "391650808"|     具体资讯的指针,具体资讯指针是这条资讯在客户端里缓存的指针，用于确认具体是哪条资讯|
     * |time|                "0"|             资讯时间|
     * |treeid|              "14375"|         资讯树id|
     * |version|             "2"|                    |
     * |tagname|             |                资讯标签,资讯内容里的stocktag参数|
     */
    
    const data = {
        stock:params.code,
        infoid: params.treeid,
        industry:params.industry,
        period:params.period,
        start:params.start,
        end:params.end,
    }
    return new Promise((resolve, reject) => {
        let sessionId = API.createSessionId('Info'); 
        window.API.use({
            method: 'Info.hookRealInfo', // 必须执行，注册协议；
            sessionId: sessionId,
        })
        window.API.use({
            method: 'info.requestInfo', // 让客户端 向资讯树请求数据
            data,
            sessionId: sessionId,
            persistent: true,
        })
        window.API.use({
            method: 'info.getInfo', //从客户端缓存中获取数据
            data,
            sessionId: sessionId,
            persistent: true,
            success: async function (res) {
                res = eval(res)
                let infoid = res.infoid
                let resData = res.data
                let result  = await getInfoObjs({
                    infoid,
                    objIds: resData
                },sessionId)
                if (result && result.length !== 0) {
                    console.log('客户端返回数据',result);
                    resolve(result)
                }else{
                    console.log('%c客户端返回数据为空','color:red',res);
                }
            }
        })

        /**
         * 以下逻辑为客户端tongzhipeng@myhexin.com提供的加载逻辑
         * let sessid = API.createSessionId('Info')
            console.log(1)
            API.use({method:'Info.hookRealInfo', persistent:true, sessionId:sessid})
            console.log(2)

            API.use({method:'Info.getInfo', data:{stock:'000010', infoid:'14375'}, sessionId:sessid, success:function(data) {
                    //alert('info=' + data)
                    console.log('4444',000010);
                    console.log('info=', data)
                    let res = eval(data)
                    let infoid = res.infoid
                    data = res.data
                    window.API.use({
                        method: 'info.getInfoObjects',
                        data: {
                            infoid:'14375',
                            objIds:data
                        },
                        sessionId: sessid,        
                        success: function (data) {
                            console.log('4444 success',4444);
                            if(data){
            // console.log('getInfoObjects=', data)
            JSON.parse(data).map((item)=>{
                            console.log('item.title',item.title);
                            })
                            }
                            
                        },
                        error:function(){
                            console.log('444444 error');
                        }
                    })
                }} )


            API.use({method:'Info.requestInfo', data: {stock:'000010', infoid:'14375', industry:''}, sessionId:sessid, success:function(data) {
            console.log(3)
                API.use({method:'Info.getInfo', data:{stock:'000010', infoid:'14375'}, sessionId:sessid, success:function(data) {
                    //alert('info=' + data)
                    console.log('5555',5555);
                    console.log('info=', data)
                    let res = eval(data)
                    let infoid = res.infoid
                    data = res.data
                    window.API.use({
                        method: 'info.getInfoObjects',
                        data: {
                            infoid:'14375',
                            objIds:data
                        },
                        sessionId: sessid,        
                        success: function (data) {
                            // console.log('getInfoObjects=', data)
                            JSON.parse(data).map((item)=>{
                            console.log('item.title',item.title);
                            })
                        }
                    })
                }} )
            }})
         */
    })
}

/**
 * 打开新的无边框窗口
 */
export async function openNewTab (url, left, top, width, height) {
    if (!hasNewTab) hasNewTab = true
    if (!url) url = lastUrl
    lastUrl = url
    // 有时会没有返回。。 
    await openTab(url)
    //   console.log('over')
    setTimeout(async () => {
        await setTabPos(left, top, width, height)
    }, 200)
}

/**
 * 判断是否打开了无边框窗口
 */
export function checkNewTab () {
    return hasNewTab
}

/**
 * 关闭无边框窗口
 */
export async function closeNewTab () {
    if (!hasNewTab) return
    hasNewTab = false
    await setTabPos(0, 0, 0, 0)
}

/**
 * 执行打开窗口
 */
function openTab (url) {
    return new Promise((resolve, reject) => {
        window.API.use({
            method: 'Util.openURL2',
            data: {
                url: url,
                mode: 16,
                useCef: 1,
                pos: 0,
                // width: 0,
                // height: 0
            },
            success: function (data) {
                // debugger
                console.log('完成打开窗口动作,开始加载内容,url 为',url)
                resolve()
            }
        })
    })
}

/**
 * 修改外边框位置
 */
export function setTabPos (left, top, width, height) {
    // console.log('kaishi移动窗口位置')
    return new Promise((resolve, reject) => {
        window.API.use({
            method: 'Util.setWebDLgPos',
            data: {
                webType: 167772160,
                useCef: 1,
                x: left,
                y: top,
                width: width,
                height: height,
                flag: 0,
                child: 1
            },
            success: function () {
                // debugger
                console.log('移动窗口位置left,top,width,height', left,top,width,height)
                resolve()
            }
        })
    })
}

/**
 * 获取文章详情
 */
export function getSeqByObjid (params={objid, code, treeid}) {

    const data = {
        stock:params.code,
        infoid: params.treeid,
        industry:params.industry,
        period:params.period,
        start:params.start,
        end:params.end,
    }
    return new Promise((resolve, reject) => {
        let sessionId = API.createSessionId('Info')
        window.API.use({
            method: 'info.getInfo',
            data,
            sessionId: sessionId,
            persistent: true,
            success: async function (res) {
                res = eval(res)
                let infoid = res.infoid
                console.log('getSeqByObjid 返回的数据',res);
                // debugger

                window.API.use({
                    method: 'info.getInfoObject',
                    data: [infoid, params.objid],
                    success: function (data) {
                        // debugger
                        // eslint-disable-next-line
                        data = JSON.parse(data)
                        resolve(data)
                    }
                })
            }
        })
    })
}

/**
 * 获取行情
 * @param {String} blockId 标签代码
 * @param {Number} begin 开始时间
 * @param {Number} end 结束时间
 */
export const getQuatation = (blockId, begin, end) => {
    return new Promise((resolve, reject) => {
        // eslint-disable-next-line
        if (!window.API) reject()
        try {
            window.API.use({
                method: 'Quote.request',
                data: {
                    code: blockId,
                    type: ['NEW', 'CLOSE', 'PRE', 'ZHANGDIEFU'].join(','),
                    period: 'day',
                    begin: begin,
                    end: end
                },
                success: function (data) {
                    window.API.use({
                        method: 'Quote.getData2',
                        data: {
                            code: blockId,
                            type: ['NEW', 'CLOSE', 'PRE', 'ZHANGDIEFU'],
                            period: 'day',
                            mode: 'after',
                            time: {
                                begin: begin,
                                end: end,
                                timeFmt: 1
                            }
                        },
                        success: function (data) {
                            resolve(JSON.parse(data)[blockId])
                        }
                    })
                },
                error: function () {
                    resolve()
                }
            })
        } catch (e) {
            this.$client.showBrowserDlgTip({text: e})
        }
    })
}

/**
 * 调用注册
 */
export const goRegister = () => {
    window.API.use({
        method: 'Util.isGuestAccount',
        success: function () {
            window.API.use({
                method: 'Util.ShowGuestRegisterDlg2'
            })
        }
    })
}

/**
 * 调用登录
 */
export const goLogin = () => {
    window.API.use({
        method: 'Util.isGuestAccount',
        success: function (data) {
            window.API.use({
                method: 'Util.reStartHX'
            })
        }
    })
}

/**
 * 获取标签内容
 */
export function getTagInfo (treeid) {
    return new Promise((resolve, reject) => {
        let sessionId = API.createSessionId('Info')
        window.API.use({
            method: 'info.GetAllStockTags',
            data: [treeid, ''],
            sessionId: sessionId,
            persistent: true,
            success: async function (res) {
                let resFunc = function (data) { //eslint-disable-line
                    let res = [...new Set(data.data.map(item => {
                        return item.split('_')[0]
                    }))]
                    resolve(res)
                }
                eval(`resFunc${res}`) //eslint-disable-line
            },
            error: function () {
                reject(new Error('Get tag list error'))
            }
        })
    })
}

// 打开股市日记
export function showJourney(){
    window.API.use({
        method:'Util.postCommand',
        data:[1, 31313],
        success: function(){}
    });
}
// 查看当前时间是否交易时间 
export function isTradeTime(code){
    return new Promise((resolve, reject) => {
        window.API.use({
            method:'Quote.isTradeTime',
            data: code,
            success: function(res){
                // console.log(res)
                resolve( res)
            }
        });
    })
}
// 查看当前时间服务器时间
export function getServerTime(){
    return new Promise((resolve, reject) => {
        window.API.use({
            method:'Quote.getServerTime',
            success: function(res){
                resolve( res)
            }
        });
    })
}
// 查看当前最近交易时间
export function getMarketCurrentTime(code){
    return new Promise((resolve, reject) => {
        window.API.use({
            method:'Quote.getMarketCurrentTime',
            data: {code,period: 16384},
            success: function(res){
                resolve( res)
            }
        });
    })
}
// 跳转分时页面
export function switchCode(code){
    return new Promise((resolve, reject) => {
        window.API.use({
            method:'Quote.switchCode',
            data: code,
            success: function(res){
                resolve( res)
            }
        });
    })
}
// 跳转概念页面 id-页面id  period 固定8192 code code
export function switchPage(params){
    return new Promise((resolve, reject) => {
        window.API.use({
            method:'Quote.switchPage',
            data: params,
            success: function(res){
                resolve( res)
            }
        });
    })
}
// 跳转概念页面 id-页面id  period 固定8192 code code
export function switchBlock(params){
    return new Promise((resolve, reject) => {
        window.API.use({
            method:'Quote.switchBlock',
            data: params,
            success: function(res){
                resolve( res)
            }
        });
    })
}


// 消息注册回调
export function registerEventNotify(func){
    return new Promise((resolve, reject) => {
        var utilSessionId = window.API.createSessionId('Util');
        window.API.use({
            method:'Util.registerEventNotify',
            persistent: true,
            data:1025,
            sessionId:utilSessionId,
            success:function(data){
                func(data)
                // resolve( data)
            }
        });
    })
}

// 获取皮肤状态
export function getBrowserDlgSkin(){
    return new Promise((resolve, reject) => {
        window.API.use({
            method:'Info.getBrowserDlgSkin',
            success:function(data){
                resolve( data)
            }
        });
    })
}

// 判断当前tab是否正在展示
export function getCurBrowserDlg(cb) {
    return new Promise((resolve, reject) => {
        window.API.use({
            method:"external.registerEvent",
            data:"onshow",
            persistent:true,
            sessionId:e,
            callbackName:"onshow",
            success:function(data){
                debounce(cb, data, 0)
            },
        })
    })
}

// 打开新标签页
export function openBrowserDlgNewUrl( params={url:'baidu.com',name:'baidu'}){
    return new Promise((resolve, reject) => {
        window.API.use({
            method:'Info.openBrowserDlgNewUrl',
            data: params,
            success:function(data){
                resolve( data)
            }
        });
    })
}

// 设置当前网页名字
export function setBrowserDlgTabName(name='新标签页'){
    return new Promise((resolve, reject) => {
        window.API.use({
            method:'Info.setBrowserDlgTabName',
            data:name,
            success:function(data){
                console.log('网页名字', data, name)
                resolve( data)
            }
        });
    })
}
// 设置下拉menu内容
export function setBrowserDlgMenu(data={
    "menu":[
        {
            "name":"name1",
            "msg":"responcedata1",
            "type":0,
            "notify":0
        },{
            "name":"name3",
            "value":[
                {
                    "name":"11",
                    "msg":"responcedata3"
                },{
                    "name":"22",
                    "msg":"responcedata4"
                },{
                    "name":"33",
                    "msg":"responcedata5"
                }
            ],
            "select":"11",
            "type":1,
            "notify":1
        }
    ]
}){
    return new Promise((resolve, reject) => {
        window.API.use({
            method:'Info.setBrowserDlgMenu',
            data: JSON.stringify(data),
            success:function(data){
                resolve( data)
            }
        });
    })
}
// 控制资讯框最小化
export function minisizeBrowserDlg(){
    return new Promise((resolve, reject) => {
        window.API.use({
            method:'Info.minisizeBrowserDlg',
            // data:name,
            success:function(data){
                resolve( data)
            }
        });
    })
}
/**
 * 
 * data:{'text':"****",'time':2000,'alpha':0}
参数text为tip的具体内容
time为tip显示时长，可不加，默认2000毫秒
alpha为是否透明渐隐，可不加，为0表示直接消失，为1表示渐渐透明化，默认为直接消失
 */
// 显示居中的tip
export function showBrowserDlgTip(params){
    let data  = Object.assign({},{'text':"操作成功!",'time':2000,'alpha':0},params)
    return new Promise((resolve, reject) => {
        window.API.use({
            method:'Info.showBrowserDlgTip',
            data: data,
            success:function(json){
                resolve(json)
            }
        });
    })
}

//网页前进
export function GoForward(){
    return new Promise((resolve, reject) => {
        window.API.use({
            method:'Info.GoForward',
            data: params,
            success:function(data){
                resolve( data)
            }
        });
    })
}

//网页后退
export function GoBack(){
    return new Promise((resolve, reject) => {
        window.API.use({
            method:'Info.GoBack',
            data: params,
            success:function(data){
                resolve( data)
            }
        });
    })
}

//网页刷新
export function Refresh(){
    return new Promise((resolve, reject) => {
        window.API.use({
            method:'Info.Refresh',
            data: params,
            success:function(data){
                resolve( data)
            }
        });
    })
}

//设置网页缓存
/**
 * data:{'key':"***",'value':"***"}
 */
export function setBrowserKeyValue(params){
    return new Promise((resolve, reject) => {
        window.API.use({
            method:'Info.setBrowserKeyValue',
            data: params,
            success:function(data){
                resolve( data)
            }
        });
    })
}
// 获取网页缓存
/**
 * data为key字符串
 */
export async function getBrowserValue(value){
    return new Promise((resolve, reject) => {
        window.API.use({
            method:'Info.getBrowserValue',
            data: value,
            success:function(data){
                resolve( data)
            }
        });
    })
}

export function IsInBrowserDlg(){
    return new Promise((resolve) => {
        window.API.use({
            method: 'external.IsInBrowserDlg',
            success: function (data) {
                if(data == 1){
                    resolve('inBrowserDlg')
                }else{
                    resolve('notBrowserDlg')
                }
            },
            error() {
                resolve('oldVersion')
            }
        });
    })
}

// 将缓存保存到文件，永久缓存
export function setStorageInFile(params) {
    return new Promise((resolve, reject) => {
        window.API.use({
            method: 'external.getUserPath',
            success: function (data) {
                const userPath = data;
                const thsExammarketPath = userPath+'fontsize.txt';
                window.API.use({
                    method: 'fileWriter.open',
                    data: thsExammarketPath,
                    success: function () {
                        window.API.use({
                            method: 'fileWriter.write',
                            data: params,
                            success: function (str) {
                                resolve(str);
                                window.API.use({
                                    method: 'fileWriter.close',
                                    success: function (data) {}
                                });
                            }
                        });
                    }
                });
            }
        });
    })
}

// 读取文件缓存
export function getStorageFromFile(){
    return new Promise((resolve, reject) => {
        window.API.use({
            method: 'external.getUserPath',
            success: function (data) {
                const userPath = data;
                const thsExammarketPath = userPath+'fontsize.txt';
                window.API.use({
                    method: 'fileReader.open',
                    data: thsExammarketPath,
                    success: function (d) {
                        if(!d){
                            const customData = '';
                            reject(d);
                        }
                        window.API.use({
                            method: 'fileReader.read',
                            success: function (str) {
                                resolve(str);
                                window.API.use({
                                    method: 'fileReader.close',
                                    success: function (data) {}
                                });
                            }
                        });
                    }
                });
            }
        });
    })
}

export function debounce(cb, data, wait) {
    if (flagTimer === true) {
        flagTimer = false
        setTimeout(() => {
            cb(data)
            flagTimer = true;
        }, wait);
    }
}
export function isbrokerApp(){
    return new Promise((resolve,reject)=>{
        window.API.use({
            method: 'Passport.get',
            data: 'm_qs',
            //sessionId:t,
            //persistent:true,
            success:function (data){ 
                resolve(data)
            },
            error:function(errorcode,errormsg){
                console.log(errorcode,errormsg,'通行证')
            }
        });
    })
}